import {
  Account,
  AspirationSites,
  Donor,
  Drug,
  OptionSet,
  ScheduleMaster,
  Semen,
  ShipmentGroup,
  Sire,
  Site,
  StringMap,
  SystemUser,
} from '@/rtk-query.gql';

export enum LookupsActions {
  UPDATE_ACCOUNTS = 'lookups/UPDATE_ACCOUNTS',
  UPDATE_ASPIRATION_SITES = 'lookups/UPDATE_ASPIRATION_SITES',
  UPDATE_CSR = 'lookups/UPDATE_CSR',
  UPDATE_DONORS = 'lookups/UPDATE_DONORS',
  UPDATE_FERTILIZATION_SITES = 'lookups/UPDATE_FERTILIZATION_SITES',
  UPDATE_FSH_DRUGS = 'lookups/UPDATE_FSH_DRUGS',
  UPDATE_FSH2_DRUGS = 'lookups/UPDATE_FSH2_DRUGS',
  UPDATE_SEMEN = 'lookups/UPDATE_SEMEN',
  UPDATE_SEMEN_LOCATIONS = 'lookups/UPDATE_SEMEN_LOCATIONS',
  UPDATE_SCHEDULES = 'lookups/UPDATE_SCHEDULES',
  UPDATE_SHIPMENT_GROUPS = 'lookups/UPDATE_SHIPMENT_GROUPS',
  UPDATE_OPTION_SETS = 'lookups/UPDATE_OPTION_SETS',
}

export type LookupsType = {
  accounts: Account[];
  aspirationSites: AspirationSites[];
  csr: SystemUser[];
  donors: Donor[];
  fertilizationSites: Site[];
  fshDrugs: Drug[];
  fsh2Drugs: Drug[];
  semen: Semen[];
  semenLocations: StorageLocation[];
  schedules: ScheduleMaster[];
  shipmentGroups: ShipmentGroup[];
  sires: Sire[];
  stringMaps: StringMap[];
  optionSets: OptionSet[];
};

export const initialState: LookupsType = {
  accounts: [],
  aspirationSites: [],
  csr: [],
  donors: [],
  fertilizationSites: [],
  fshDrugs: [],
  fsh2Drugs: [],
  semen: [],
  semenLocations: [],
  schedules: [],
  shipmentGroups: [],
  sires: [],
  stringMaps: [],
  optionSets: [],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case LookupsActions.UPDATE_ACCOUNTS: {
      return {
        ...state,
        accounts: action.accounts,
      };
    }
    case LookupsActions.UPDATE_ASPIRATION_SITES: {
      return {
        ...state,
        aspirationSites: action.aspirationSites,
      };
    }
    case LookupsActions.UPDATE_CSR: {
      return {
        ...state,
        csr: action.csr,
      };
    }
    case LookupsActions.UPDATE_DONORS: {
      return {
        ...state,
        donors: action.donors,
      };
    }
    case LookupsActions.UPDATE_FERTILIZATION_SITES: {
      return {
        ...state,
        fertilizationSites: action.fertilizationSites,
      };
    }
    case LookupsActions.UPDATE_FSH_DRUGS: {
      return {
        ...state,
        fshDrugs: action.fshDrugs,
      };
    }
    case LookupsActions.UPDATE_FSH2_DRUGS: {
      return {
        ...state,
        fsh2Drugs: action.fsh2Drugs,
      };
    }
    case LookupsActions.UPDATE_SEMEN: {
      return {
        ...state,
        semen: action.semen,
      };
    }
    case LookupsActions.UPDATE_SEMEN_LOCATIONS: {
      return {
        ...state,
        semenLocations: action.semenLocations,
      };
    }
    case LookupsActions.UPDATE_SCHEDULES: {
      return {
        ...state,
        schedules: action.schedules,
      };
    }
    case LookupsActions.UPDATE_SHIPMENT_GROUPS: {
      return {
        ...state,
        shipmentGroups: action.shipmentGroups,
      };
    }
    case LookupsActions.UPDATE_OPTION_SETS: {
      return {
        ...state,
        optionSets: action.optionSets,
      };
    }
    default:
      return state;
  }
}
